import styled from 'styled-components';
export const Wrap = styled.div`
	width: 100%;
	height: 400px;
	margin-top: 20px;
`;
